export class ChartElevationPoint {
  index: number;
  datasetIndex: number;
  ele = 0;
  dst = 0;
  lat = 0;
  lon = 0;
}
